import { render, staticRenderFns } from "./paper.vue?vue&type=template&id=10a85998&scoped=true&"
import script from "./paper.vue?vue&type=script&lang=js&"
export * from "./paper.vue?vue&type=script&lang=js&"
import style0 from "./paper.vue?vue&type=style&index=0&id=10a85998&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a85998",
  null
  
)

export default component.exports